export default __webpack_public_path__ + "static/media/we_platform.6ed89082.jpeg";